import QtdModulo from '../../ModulosCrefito/QtdModulo'
import Epi from '../../ModulosCrefito/Modulos/Epi'
import ParametrosAssistenciais from '../../ModulosCrefito/Modulos/ParametrosAssistenciais'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Consultorio = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL" modulo="epi" />
            <Epi modulo="epi" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="parametros" />
            <ParametrosAssistenciais modulo="parametros" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Consultorio